import { Layout as AntLayout } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
// import { initAnalytics } from '../../../services/analyticsService';
import "../../../styles/antd.scss";

import Header from '../Header';
import "./index.scss";
import Sidebar from '../../../pages/OnboardingModal/Components/Sidebar';
import AutoApplyModal from '../../../pages/SavedJobs/Components/AutoApplyModal';
import OnboardingModal from '../../../pages/OnboardingModal';
import ApplicationKitModal from '../../../modals/ApplicationKitModal';
import CoverLetterModal from '../../../modals/CoverLetterModal';
import ImportJobModal from '../../../modals/ImportJobModal';
import { isMobile } from '../../../services/clientService';
import FeedbackModal from '../../../modals/FeedbackModal';
import PaymentSuccessModal from '../../../modals/PaymentSuccessModal';
import { saveJobId, saveTrackingParams } from '../../../services/analyticsService';

const LayoutComponent = (props) => {
    const location = useLocation();
    const [hideSidebar, setHideSidebar] = useState(false);

    useEffect(() => {
        saveTrackingParams();
        saveJobId();
        
    }, []);

    useEffect(() => {
        const shouldHideSidebar = isMobile() || location.pathname.includes('auth') || location.pathname.includes('resume-builder')
        setHideSidebar(shouldHideSidebar);
    }, [location.pathname]);

    return (
        <AntLayout className={`layout ${hideSidebar ? 'full' : ''}`}>
            <Header />
            {!hideSidebar && <Sidebar />}
            <div className="layout-content">{props.children}</div>
            <ApplicationKitModal />
            <CoverLetterModal />
            <ImportJobModal />
            <FeedbackModal />
            <PaymentSuccessModal />
        </AntLayout>
    );
};

export default LayoutComponent;
